<h1 mat-dialog-title>{{ title | translate }}</h1>

<div mat-dialog-content>
  <p [innerHTML]="message | translate | safeHtml"></p>
</div>

<div mat-dialog-actions class="row">
  <div class="col">
    <button mat-raised-button id="confirm-dialog-dismiss-button" class="float-left" color="accent" (click)="onDismiss()">{{ dismissButtonLabel ?? ('No' | translate) }}</button>
    <button mat-raised-button id="confirm-dialog-confirm-button" class="float-right" color="primary" (click)="onConfirm()">{{ confirmButtonLabel ?? ('Yes' | translate) }}</button>
  </div>
</div>
